import React, { useEffect, useState } from "react";
import { IFilter } from "../../../../types/filter.type";
import FilterText from "../FilterText";
import WrapperFilter from "../group/WrapperFilter";

function FilterUsergroup({ loading, setCondition }: IFilter) {
  const originFilter: { [key: string]: any } = {
    group_name: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);

  const refreshFilter = () => {
    setFilter(originFilter);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.group_name) {
      condition.group_name = {
        $regex: filter.group_name?.split(" ")?.join(".*"),
        $options: "i",
      };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Tên nhóm"
        placeholder="Tìm theo tên nhóm"
        defaultValue={filter.group_name}
        onChange={(val) => setFilter({ ...filter, group_name: val })}
      />
    </WrapperFilter>
  );
}

export default FilterUsergroup;
